import { useDocumentTitleEntity } from '@components/DocumentTitle'
import FormCard from '@components/FormCard'
import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import { BusinessProfile } from '@components/business/businessProfile/BusinessProfile'
import { CompanyContact } from '@components/business/companyContact/CompanyContact'
import { CompanyStatuses } from '@components/business/companyStatuses/CompanyStatuses'
import { resetBusinessProfileQueryAndIds } from '@store/business/BusinessProfileReducer'
import { resetCompanyContactQueryAndIds } from '@store/business/CompanyContactReducer'
import {
  getCompanyWithId,
  resetCompanyQueryAndIds,
  selectCompanyById,
  setSelectedCompany,
} from '@store/business/CompanyReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import { Col, Space } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const CompanyPage = () => {
  const dispatch = useAppDispatch()
  const { hasAccess } = useHasAccess()
  const { companyId } = useParams<{ companyId: string }>()
  const company = useAppSelector(selectCompanyById(Number(companyId)))
  useDocumentTitleEntity(company?.name)

  useEffect(() => {
    dispatch(resetCompanyQueryAndIds(initialQuery))
    dispatch(resetCompanyContactQueryAndIds(initialQuery))
    dispatch(resetBusinessProfileQueryAndIds(initialQuery))

    dispatch(getCompanyWithId(Number(companyId)))
    dispatch(setSelectedCompany(Number(companyId)))
  }, [companyId])

  if (!company) {
    return <></>
  }

  return (
    <Page
      rowGutter={[32, 32]}
      noWrapWithCol
      pageTitle={{
        level: 3,
        title: `${company.name}`,
        toolbar: (
          <Space>
            <CompanyStatuses.StatusTag id={company.status} />
            <SBRM.Actions
              actions={[SBRMAction.Update]}
              entity={Entity.company}
              entityId={company.id}
            />
          </Space>
        ),
      }}
    >
      <Col span={14}>
        <CompanyContact.Table companyId={company.id} />
      </Col>
      <Col span={10}>
        <FormCard
          title="Policies"
          entity={Entity.company}
          action={SBRMAction.Update}
          sections={['policies']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>

      <Col span={24}>
        <BusinessProfile.Table companyId={company.id} />
      </Col>
    </Page>
  )
}

export default CompanyPage
